/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandCraft = createReactComponent("outline", "brand-craft", "IconBrandCraft", [["path", { "d": "M20 4h-8a8 8 0 1 0 0 16h8a8 8 0 0 0 -8 -8a8 8 0 0 0 8 -8", "key": "svg-0" }], ["path", { "d": "M4 12h8", "key": "svg-1" }], ["path", { "d": "M12 4v16", "key": "svg-2" }]]);

export { IconBrandCraft as default };
//# sourceMappingURL=IconBrandCraft.mjs.map
